import { useCallback } from 'react';
import { Annotation } from './use-focus-annotation-mapper';
import { FocusFile } from '../shared/file-importer/types';
import { ImportSelections } from './use-focus-import-selections';
import { AnnotationCategory, AnnotationCategoryRequest, useCreateAnnotationCategoriesBatch } from 'api/annotations';

export const useHandleCreateAnnotations = (
    focusFile: FocusFile | undefined,
    categoryMapper: (focusFile: FocusFile | undefined, selections: ImportSelections) => AnnotationCategoryRequest[],
    annotationMapper: (
        annotationCategories: AnnotationCategory[],
        focusFile: FocusFile | undefined,
        selections: ImportSelections,
    ) => Annotation[],
) => {
    const mutate = useCreateAnnotationCategoriesBatch();
    return useCallback(
        async (selections: ImportSelections, onSuccess?: () => void, onError?: () => void) => {
            try {
                const annotationCategories = categoryMapper(focusFile, selections);
                const categoryResponse = await mutate.mutateAsync(annotationCategories);
                // eslint-disable-next-line no-console
                console.log('categories', annotationCategories);
                const annotations = annotationMapper(categoryResponse, focusFile, selections);
                // todo call api
                // eslint-disable-next-line no-console
                console.log('annotations', annotations);
                onSuccess?.();
            } catch (error) {
                onError?.();
            }
        },
        [annotationMapper, categoryMapper, focusFile, mutate],
    );
};
